import { capitalize } from 'vue';

import CreativeFilePlacementType from '@/common/enums/CreativeFilePlacementType.enum';
import { IOption } from '@/common/models/Option';
import i18n from '@/vueI18n';

class CreativeFilePlacementTypeOptions {
  static options(): IOption[] {
    return [
      {
        value: CreativeFilePlacementType.InArticle,
        name: capitalize(i18n.global.t('options.creativeFilePlacementType.inArticle')),
      },
      {
        value: CreativeFilePlacementType.InBanner,
        name: capitalize(i18n.global.t('options.creativeFilePlacementType.inBanner')),
      },
      {
        value: CreativeFilePlacementType.InFeed,
        name: capitalize(i18n.global.t('options.creativeFilePlacementType.inFeed')),
      },
      {
        value: CreativeFilePlacementType.InStream,
        name: capitalize(i18n.global.t('options.creativeFilePlacementType.inStream')),
      },
      {
        value: CreativeFilePlacementType.Interstitial,
        name: capitalize(i18n.global.t('options.creativeFilePlacementType.interstitial')),
      },
    ];
  }
}

export default CreativeFilePlacementTypeOptions;
